import { useState, useEffect } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../config';
import { useSelector } from 'react-redux';

const useClassCount = (classId, live=true) => {
    const [learners, setLearners] = useState(true);
    const [classCount, setClassCount] = useState(0);
    const ip = useSelector((state) => state.ip.address)
    const [countLoading, setCountLoading] = useState(true)
    const page = useSelector((state)=> state.route.currentRoute)

    useEffect(() => {
        if (!classId || !live) {
                setCountLoading(false)
                return;
            }
        const fetchClassCount = async () => {
            const getEnrolledClassCount = httpsCallable(functions, 'getenrolledclasscount');
            const res = await getEnrolledClassCount({ classId, ip, page });
            setCountLoading(false);
            setLearners(res.data.learners)
            setClassCount(res.data.classCount);
        };
            fetchClassCount();
    }, [classId, live, ip, page]);

    return { learners, classCount, countLoading};
};

export default useClassCount;
